var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright"},[_c('p',[_vm._v("Copyright @2022 客维智能科技（广州）有限公司 版权所有")]),_c('p',[_vm._v("粤ICP备11053761号")])])}]

export { render, staticRenderFns }